export enum PermissionClaim {
  RequestContact = 'RequestContact',
  DiscoverContact = 'DiscoverContact',
  DiscoverIamRole = 'DiscoverIamRole',
  CustomerOnboardingMutating = 'CustomerOnboardingMutating',
  ReadMaintenance = 'ReadMaintenance',
  ScheduleMaintenance = 'ScheduleMaintenance',
  ReadCapabilityManagement = 'ReadCapabilityManagement',
  ReadSiteHealthAndStatus = 'ReadSiteHealthAndStatus',
  ReadContactIdentifyingInformation = 'ReadContactIdentifyingInformation',
  ReadSiteAntennaMetrics = 'ReadSiteAntennaMetrics',
  ScheduleRTS = 'ScheduleRTS',
  CustomerOnboardingValidation = 'CustomerOnboardingValidation',
}
